import { CaseReportParamsType, CaseReportRespType } from './caseReport'

export const transformCaseReportRespToCaseReportParams = (
  caseReportResp: CaseReportRespType
): CaseReportParamsType => {
  const caseReportParams = { ...caseReportResp }
  delete caseReportParams.attachmentList
  const { caseME, caseCA, caseBA, casePL, casePA } = caseReportResp
  if (caseME && caseME.attachmentList) {
    // @ts-ignore
    delete caseME.attachmentList
    // @ts-ignore
    const { treatmentExpenses } = caseReportParams.caseME
    //console.log(treatmentExpenses, 'treatmentExpenses')
    treatmentExpenses?.OP?.costs?.map((cost: any) => {
      delete cost.attachmentList
      return { ...cost }
    })
    treatmentExpenses?.IP?.costs?.map((cost: any) => {
      delete cost.attachmentList
      return { ...cost }
    })
    treatmentExpenses?.OTH?.costs?.map((cost: any) => {
      delete cost.attachmentList
      return { ...cost }
    })
  }
  if (caseBA && caseBA.attachmentList) {
    // @ts-ignore
    delete caseReportParams.caseBA.attachmentList
    // @ts-ignore
    const { items } = caseReportParams.caseBA
    items?.map((item: any) => {
      delete item.attachmentList
      return { ...item }
    })
  }
  if (caseCA && caseCA.attachmentList) {
    // @ts-ignore
    delete caseReportParams.caseCA.attachmentList
  }
  if (casePA && casePA.attachmentList) {
    // @ts-ignore
    delete caseReportParams.casePA.attachmentList
  }
  if (casePL) {
    if (casePL.items) {
      // @ts-ignore
      const { items } = caseReportParams.casePL
      items?.map((item: any) => {
        delete item.attachmentList
        return { ...item }
      })
    }
    if (casePL.persons) {
      // @ts-ignore
      const { persons } = caseReportParams.casePL
      persons?.map((person: any) => {
        delete person.attachmentList
        return { ...person }
      })
    }
  }

  //console.log(caseReportParams, 'caseReportResp')

  return caseReportParams
}
